module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_assign__;